// Diagnóstico AO VIVO do rébus, espelhando os guards do replace no servidor
// (`PATCH /admin/jogos/:id/rebus` devolve 422 com solução ou imagem vazia).
//
// O servidor continua sendo a autoridade; isto existe para o autor não descobrir o
// problema só ao salvar.

import type { Diagnostic } from '../../types';
import type { RebusDoc } from './doc';

export function validate(doc: RebusDoc): Diagnostic[] {
  const out: Diagnostic[] = [];

  if (doc.solucao.trim() === '') {
    out.push({
      level: 'error',
      message: 'O rébus está sem solução — é a resposta que o jogador digita.',
      ref: 'solucao',
    });
  }

  if (doc.imagem.trim() === '') {
    // O NÍVEL depende de o jogo já existir, e a razão é de fluxo, não de gosto: a
    // rota de upload é `POST /admin/jogos/:id/rebus/imagem` e precisa de um jogo
    // criado. Cobrar a imagem como `error` antes do primeiro save trancaria a
    // criação num impasse (sem save não há jogo; sem jogo não há upload). Depois de
    // criado, aí sim é `error`: rébus sem imagem não é jogável, e o replace do
    // servidor recusa com 422.
    out.push(
      doc.idJogo == null
        ? {
            level: 'warning',
            message:
              'Ainda sem imagem. Salve para criar o jogo e depois suba a imagem — sem ela o rébus não é jogável.',
            ref: 'imagem',
          }
        : {
            level: 'error',
            message: 'O rébus está sem imagem — sem ela não há o que o jogador decifre.',
            ref: 'imagem',
          },
    );
  }

  if (doc.numeracao.trim() === '') {
    // "numeracao" é a COLUNA; o que ela guarda é a dica textual (ver doc.ts).
    out.push({
      level: 'warning',
      message: 'Sem dica: o jogador vê só a imagem. Não bloqueia o save.',
      ref: 'numeracao',
    });
  }

  return out;
}
